module.exports = __webpack_public_path__ + "img/huhaibo.6278fdc8.png";